import API from '../../../helpers/request/api';

const api = () => new API();

const communityUserProfileData = extra => `{
  id
  qty_valid_posts
  qty_valid_post_likes
  qty_visible_comments
  qty_visible_comment_likes
  qty_visible_comment_best_comments
  permission
  is_active
  is_muted
  user {
    id
    name
    email
    status
    photo
  }
  badges {
    id
    name
    medal_color
    tie_color
    icon {
      icon
    }
    community_badge_image_url
  }
  user_badges {
    id
    badge {
      id
      name
      medal_color
      tie_color
      icon {
        icon
      }
      community_badge_image_url
    }
  }
  qty_badges
  ${extra}
}`;

const emailSettings = `email_settings {
    kind
  }`;


const fetch = (communityId, page, orderBy, search = '') => {
  const query = {
    variables: { communityId, page, orderBy, search },
    query: `query community_users($communityId: String!, $page: Int!, $orderBy: String, $search: String) {
      community_users(
        community_id: $communityId,
        page: $page,
        order_column: $orderBy,
        order_attribute: "DESC",
        by_data: $search,
      ) ${communityUserProfileData(emailSettings)}
    }`,
  };

  return api().get(query);
};

const searchUsers = (data) => {
  const { search, communityId } = data;

  const query = {
    query: `query search_community_users {
      search_community_users(
        search: "${search}",
        community_id: ${communityId},
      ) {
        id
        user {
          id
          name
          email
          status
          photo
        }
      }
    }`,
  };

  return api().get(query);
};

const updateState = (userData) => {
  const { id, is_muted, permission, is_active } = userData;

  const query = {
    variables: { id: Number(id), is_muted, permission, is_active },
    query: `mutation updateCommunityUserState($id: Int!, $permission: String!, $is_active: Boolean!, $is_muted: Boolean!) {
      updateCommunityUserState(
        input: {
          id: $id,
          permission: $permission,
          is_active: $is_active,
          is_muted: $is_muted,
        }
      )
      {
        community_user {
          id,
          permission
          is_active
          is_muted
          user {
            id
            name
            email
            status
            photo
          }
        }
        message
      }
    }`,
  };

  return api().get(query);
};

const getCount = (communityId, search = '') => {
  const query = {
    variables: { communityId, search },
    query: `query count_community_users($communityId: Int!, $search: String) {
      count_community_users(community_id: $communityId, by_data: $search) {}
    }`,
  };

  return api().get(query);
};

const fetchNotifications = (communityId, page) => {
  const query = {
    query: `query community_user_notifications {
      community_user_notifications(
        community_id: ${communityId},
        page: ${page},
      ) {
        id
        message
        kind
        created_at
        read
        community_post_id
        community_post_comment_id
        community_user_badge_id
        sender_user {
          name
          photo
        }
        community_sender_user {
          id
        }
      }
    }`,
  };

  return api().get(query);
};

const fetchTotalNotifications = (communityId) => {
  const query = {
    query: `query count_community_user_notifications {
      count_community_user_notifications(community_id: ${communityId}) {}
    }`,
  };

  return api().get(query);
};

const updateReadNotification = (notificationId, notificationRead) => {
  const query = {
    query: `mutation updateReadNotification {
      updateReadNotification(
        input: {
          notification_id: [${notificationId}]
          notification_read: ${notificationRead}
        }
      )
      {
        community_notifications {
          id
          read
          kind
          created_at
          sender_user {
            name
            photo
          }
        }
        message
      }
    }`,
  };

  return api().get(query);
};

const markAllAsReadNotification = (communityId) => {
  const query = {
    query: `mutation markAllAsRead {
      markAllAsRead(
        input: {
          community_id: ${communityId}
        }
      )
      {
        message
      }
    }`,
  };

  return api().get(query);
};

const updateEmailSettings = (userData) => {
  const { communityUserId, kinds } = userData;

  const query = {
    variables: { kinds },
    query: `mutation updateCommunityUserEmailSettings($kinds: [String]) {
      updateCommunityUserEmailSettings(
        input: {
          community_user_id: ${communityUserId},
          kinds: $kinds,
        }
      )
      {
        community_user {
          id
          email_settings {
            kind
          }
        }
        message
      }
    }`,
  };

  return api().get(query);
};

const getProfileData = (communityUserId, isSameUser = false) => {
  const attributes = isSameUser ?
    communityUserProfileData(emailSettings) :
    communityUserProfileData('');

  const query = {
    variables: { communityUserId },
    query: `query community_user_profile_data($communityUserId: String!) {
      community_user_profile_data(
        community_user_id: $communityUserId
      )
      ${attributes}
    }`,
  };

  return api().get(query);
};


const assignBadges = (data, isSameUser = false) => {
  const attributes = isSameUser ?
    communityUserProfileData(emailSettings) :
    communityUserProfileData('');

  const query = {
    variables: data,
    query: `mutation assignBadges($userId: String!, $badges: [Int]!) {
      assignBadges(
        input: {
          community_user_id: $userId,
          badges: $badges,
        }
      )
      {
        community_user ${attributes}
        message
      }
    }`,
  };

  return api().get(query);
};

export default {
  fetch,
  getCount,
  searchUsers,
  updateState,
  fetchNotifications,
  fetchTotalNotifications,
  updateReadNotification,
  markAllAsReadNotification,
  updateEmailSettings,
  getProfileData,
  assignBadges,
};



// WEBPACK FOOTER //
// ./src/screens/Community/queries/user.js